import React, { useState } from "react";
import { SideBar } from "../../components/SideBar/SideBar";
import InputBox from "../../components/Input/Input";
import Label from "../../components/Label/Label";

interface DisplayProps {
  userRole: string;
}

const Display: React.FC<DisplayProps> = ({userRole}) => {
  const [selectedMode, setSelectedMode] = useState("option1");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedMode(event.target.value);
  };

  return (
    <div className="container px-5">
      <div className="edit-profile-header py-4">Settings</div>
      <div className="row">
        <div className="col-12 col-lg-2 my-3">
          <SideBar ActiveItem="Preferences" userRole={userRole}/>
        </div>
        <div className="profile-content col-12 col-lg-10 my-3">
          <div className="heading">Preferences</div>
          <div className="row mt-4 mb-5">
          <div className="sub-heading">Display Mode</div>
            <div className="col-lg-5 col-md-7 col-sm-12 px-0 mx-0">
              <div className="form-check ps-3 cont mb-3 mt-1">
                <InputBox
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios1"
                  value="option1"
                  checked={selectedMode === "option1"}
                  onChange={handleChange}
                  className="form-check-input form-input p-2 mt-2"
                />
                <div>
                <Label
                  className="form-check-label h5 my-0 py-0 heading"
                  htmlFor="exampleRadios1"
                  text="Auto"
                />
                <br />
                <div className="sub-heading">
                  Use your device's default mode
                </div></div>
              </div>

              <div className="form-check ps-3 cont my-3">
                <InputBox
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios2"
                  value="option2"
                  checked={selectedMode === "option2"}
                  onChange={handleChange}
                  className="form-check-input form-input p-2 mt-2"
                />
                <div>
                <Label
                  className="form-check-label h5 my-0 py-0 heading"
                  htmlFor="exampleRadios2"
                  text="Light"
                />
                <div className="sub-heading">Always use light mode</div>
                </div>
              </div>

              <div className="form-check ps-3 cont my-3">
                <InputBox
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios3"
                  value="option3"
                  checked={selectedMode === "option3"}
                  onChange={handleChange}
                  className="form-check-input form-input p-2 mt-2"
                />
                <div>
                <Label
                  className="form-check-label h5 my-0 heading"
                  htmlFor="exampleRadios3"
                  text="Dark"
                />
                <br />
                <div className="sub-heading">Always use dark mode</div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Display;
